<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header id="modalTitle" class="modal-header">
          <slot name="header">
            <span @click="close"><h2 class="modal-button-close"><i class="fo fo-delete"/></h2></span>
          </slot>
        </header>
        <section id="modalDescription" class="modal-body">
          <slot name="body">&nbsp;</slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <a class="button block" @click="close"><span style="color: white">Übernehmen</span></a>
            <!--<span class="button block small-12" @click="close">Übernehmen</span>-->
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'modal',
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
<style>
.modal-backdrop {
  position: fixed !important;
  margin-bottom: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background-color: #FFFFFF !important;
  display: block;
  z-index: 3000 !important;
  justify-content: center !important;
  align-items: center !important;
}

.modal {
  background: #FFFFFF !important;
  box-shadow: 2px 2px 20px 1px !important;
  overflow-x: auto !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 3000 !important;
  flex-direction: column !important;
  margin-bottom: 0 !important;
}

.modal-header{
  padding: 0.9375rem 0.9375rem 0rem 0.9375rem !important;
  display: flex !important;
  justify-content: flex-end !important;
}

.modal-footer {
  left: 0;
  right: 0;
  justify-content: center !important;
  position: fixed !important;
  display: block !important;
  padding: 0.9375rem 0.9375rem 0rem 0.9375rem !important;
  bottom: 10px !important;
}

.modal-body {
  position: relative;
  padding: 0.9375rem !important;
  display: block !important;
  height: 80% !important;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;
  -o-transition: opacity .5s ease;
  -moz-transition: opacity .5s ease;
  -webkit-transition: opacity .5s ease;
}

.modal-button-close {
  font-size: 20px;
  font-weight: normal;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/common/modal.vue